/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-color-tones-generator block)");
/* eslint-enable no-console */

(function () {
    'use strict';
    const DEFAULT_HEX = '#6366f1', DEFAULT_COUNT = 10, DEFAULT_MODE = 'linear', DEFAULT_GRAY = '#808080', DEFAULT_CONTRAST = '#ffffff';
    let baseHex = DEFAULT_HEX, count = DEFAULT_COUNT, mode = DEFAULT_MODE, grayHex = DEFAULT_GRAY, viewMode = 'grid', fmtMode = 'css', contrastColor = DEFAULT_CONTRAST;
    const PRESETS = ['#ef4444', '#f97316', '#eab308', '#22c55e', '#14b8a6', '#6366f1', '#8b5cf6', '#ec4899', '#06b6d4', '#3b82f6', '#000000', '#6b7280', '#a3a3a3', '#dc2626', '#d97706', '#16a34a', '#0891b2', '#4f46e5', '#7c3aed', '#db2777'];
    const $ = id => document.getElementById(id);
    const colorPicker = $('colorPicker'), hexInput = $('hexInput'), tonesCount = $('tonesCount'), tonesMode = $('tonesMode');
    const grayPicker = $('grayPicker'), grayHexInput = $('grayHex'), grayPreview = $('grayPreview');
    const tonesGrid = $('tonesGrid'), tonesList = $('tonesList');
    const codeOutput = $('codeOutput'), btnCopy = $('btnCopy'), btnRandom = $('btnRandom'), btnReset = $('btnReset'), btnGrayReset = $('btnGrayReset');
    const presetsGrid = $('presetsGrid'), contrastColorPicker = $('contrastColor'), contrastHexInput = $('contrastHex');
    const contrastGridEl = $('contrastGrid'), toast = $('toast');

    function hexToRgb(hex) { const h = hex.replace('#', ''); const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
    function rgbToHex(r, g, b) { return '#' + [r, g, b].map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join(''); }
    function luminance(r, g, b) { const c = [r, g, b].map(v => { v /= 255; return v <= .03928 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }); return .2126 * c[0] + .7152 * c[1] + .0722 * c[2]; }
    function contrast(hex1, hex2) { const [r1, g1, b1] = hexToRgb(hex1), [r2, g2, b2] = hexToRgb(hex2); const l1 = luminance(r1, g1, b1), l2 = luminance(r2, g2, b2); const li = Math.max(l1, l2), da = Math.min(l1, l2); return (li + .05) / (da + .05); }
    function contrastLabel(r) { if (r >= 7) return { text: 'AAA', color: '#166534' }; if (r >= 4.5) return { text: 'AA', color: '#1a7a3a' }; if (r >= 3) return { text: 'AA Large', color: '#854d0e' }; return { text: 'Fail', color: '#c00' }; }

    function generateTones(hex, n, m, gray) {
        const [r, g, b] = hexToRgb(hex);
        const [gr, gg, gb] = hexToRgb(gray);
        return Array.from({ length: n }, (_, i) => {
            let t = i / (n - 1);
            if (m === 'ease') t = t * t;
            else if (m === 'strong') t = Math.pow(t, .55);
            return rgbToHex(
                Math.round(r + (gr - r) * t),
                Math.round(g + (gg - g) * t),
                Math.round(b + (gb - b) * t)
            );
        });
    }

    function getLabel(i, total) {
        if (i === 0) return { text: 'Base', isBase: true };
        if (i === total - 1) return { text: 'Gray', isBase: false };
        return { text: Math.round((i / (total - 1)) * 100) + '% gray', isBase: false };
    }

    function updateGrayPreview() {
        const canvas = grayPreview;
        const ctx = canvas.getContext('2d');
        canvas.width = canvas.offsetWidth || 700;
        const [r, g, b] = hexToRgb(grayHex);
        ctx.fillStyle = `rgb(${r},${g},${b})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    function render() {
        const tones = generateTones(baseHex, count, mode, grayHex);
        tonesGrid.innerHTML = '';
        tones.forEach((hex, i) => {
            const el = document.createElement('div'); el.className = 'shade-item';
            const { text: gl, isBase: gb } = getLabel(i, count);
            el.innerHTML = `<div class="shade-color" style="background:${hex}"></div><div class="shade-label${gb ? ' is-base' : ''}">${hex.toUpperCase()}<br><span class="shade-name">${gl}</span></div>`;
            el.addEventListener('click', () => copyHex(hex.toUpperCase())); tonesGrid.appendChild(el);
        });
        tonesList.innerHTML = '';
        tones.forEach((hex, i) => {
            const [r, g, b] = hexToRgb(hex);
            const el = document.createElement('div'); el.className = 'shade-row';
            const { text: ll, isBase: lb } = getLabel(i, count);
            el.innerHTML = `<div class="shade-row-color" style="background:${hex}"></div><div class="shade-row-hex">${hex.toUpperCase()}</div><div class="shade-row-rgb">rgb(${r}, ${g}, ${b})</div><div class="shade-row-pct" style="${lb ? 'color:#000;font-weight:700;' : ''}">${ll}</div><div class="copied-badge" id="cb${i}">Copied!</div>`;
            el.addEventListener('click', () => { copyHex(hex.toUpperCase()); const b = document.getElementById('cb' + i); b.classList.add('show'); setTimeout(() => b.classList.remove('show'), 1200); });
            tonesList.appendChild(el);
        });
        renderCode(tones); renderContrast(tones);
    }

    function renderCode(tones) {
        if (fmtMode === 'css') { codeOutput.value = ':root {\n' + tones.map((h, i) => `  --color-tone-${i + 1}: ${h};`).join('\n') + '\n}'; }
        else if (fmtMode === 'scss') { codeOutput.value = tones.map((h, i) => `$tone-${i + 1}: ${h};`).join('\n'); }
        else if (fmtMode === 'json') { const o = {}; tones.forEach((h, i) => o['tone-' + (i + 1)] = h); codeOutput.value = JSON.stringify(o, null, 2); }
        else { codeOutput.value = 'const tones = [\n' + tones.map(h => `  "${h}"`).join(',\n') + '\n];'; }
    }

    function renderContrast(tones) {
        contrastGridEl.innerHTML = '';
        tones.forEach(hex => {
            const ratio = contrast(hex, contrastColor);
            const r = ratio.toFixed(1); const { text, color } = contrastLabel(ratio);
            const el = document.createElement('div'); el.className = 'shade-item'; el.style.cursor = 'default';
            el.innerHTML = `<div class="shade-color" style="background:${hex};display:flex;align-items:center;justify-content:center;"><span style="color:${contrastColor};font-size:13px;font-weight:700;">Aa</span></div><div class="shade-label" style="font-size:9px;line-height:1.6;">${r}:1<br><span style="color:${color};font-weight:700;">${text}</span></div>`;
            contrastGridEl.appendChild(el);
        });
    }

    function buildPresets() {
        presetsGrid.innerHTML = '';
        PRESETS.forEach(hex => {
            const el = document.createElement('div'); el.className = 'palette-dot'; el.style.background = hex; el.title = hex;
            el.addEventListener('click', () => { setColor(hex); render(); }); presetsGrid.appendChild(el);
        });
    }

    function showToast(msg) { toast.textContent = msg; toast.classList.add('show'); setTimeout(() => toast.classList.remove('show'), 1800); }
    function copyHex(text) { navigator.clipboard.writeText(text).then(() => showToast('Copied: ' + text)).catch(() => { const ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); showToast('Copied: ' + text); }); }
    function setColor(hex) { baseHex = hex; colorPicker.value = hex; hexInput.value = hex.replace('#', '').toUpperCase(); hexInput.classList.remove('invalid'); }
    function setGray(hex) { grayHex = hex; grayPicker.value = hex; grayHexInput.value = hex.replace('#', '').toUpperCase(); updateGrayPreview(); }

    function resetAll() {
        count = DEFAULT_COUNT; mode = DEFAULT_MODE;
        tonesCount.value = DEFAULT_COUNT; tonesMode.value = DEFAULT_MODE;
        contrastColor = DEFAULT_CONTRAST;
        contrastColorPicker.value = DEFAULT_CONTRAST;
        contrastHexInput.value = DEFAULT_CONTRAST.replace('#', '').toUpperCase();
        setGray(DEFAULT_GRAY);
        setColor(DEFAULT_HEX); render();
    }

    colorPicker.addEventListener('input', () => { setColor(colorPicker.value); render(); });
    hexInput.addEventListener('input', () => {
        const v = hexInput.value.trim().replace('#', '');
        if (/^[0-9a-fA-F]{6}$/.test(v)) { hexInput.classList.remove('invalid'); baseHex = '#' + v; colorPicker.value = baseHex; render(); }
        else hexInput.classList.add('invalid');
    });
    grayPicker.addEventListener('input', () => { setGray(grayPicker.value); render(); });
    grayHexInput.addEventListener('input', () => {
        const v = grayHexInput.value.trim().replace('#', '');
        if (/^[0-9a-fA-F]{6}$/.test(v)) { grayHex = '#' + v; grayPicker.value = grayHex; updateGrayPreview(); render(); }
    });
    btnGrayReset.addEventListener('click', () => { setGray(DEFAULT_GRAY); render(); });
    tonesCount.addEventListener('change', () => { count = Math.max(3, Math.min(50, parseInt(tonesCount.value) || 10)); tonesCount.value = count; render(); });
    tonesMode.addEventListener('change', () => { mode = tonesMode.value; render(); });
    btnRandom.addEventListener('click', () => { const rand = Math.floor(Math.random() * 0xffffff); const r = '#' + rand.toString(16).padStart(6, '0'); setColor(r); render(); });
    btnReset.addEventListener('click', resetAll);
    document.getElementById('viewTabs').querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.getElementById('viewTabs').querySelectorAll('button').forEach(b => b.classList.remove('active')); btn.classList.add('active'); viewMode = btn.dataset.view;
            $('gridView').classList.toggle('hidden', viewMode !== 'grid'); $('listView').classList.toggle('hidden', viewMode !== 'list');
        });
    });
    document.getElementById('fmtTabs').querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            document.getElementById('fmtTabs').querySelectorAll('button').forEach(b => b.classList.remove('active')); btn.classList.add('active'); fmtMode = btn.dataset.fmt;
            renderCode(generateTones(baseHex, count, mode, grayHex));
        });
    });
    btnCopy.addEventListener('click', () => { copyHex(codeOutput.value); btnCopy.textContent = '✓'; btnCopy.classList.add('ok'); setTimeout(() => { btnCopy.textContent = 'Copy'; btnCopy.classList.remove('ok'); }, 1500); });
    contrastColorPicker.addEventListener('input', () => { contrastColor = contrastColorPicker.value; contrastHexInput.value = contrastColor.replace('#', '').toUpperCase(); renderContrast(generateTones(baseHex, count, mode, grayHex)); });
    contrastHexInput.addEventListener('input', () => { const v = contrastHexInput.value.trim().replace('#', ''); if (/^[0-9a-fA-F]{6}$/.test(v)) { contrastColor = '#' + v; contrastColorPicker.value = contrastColor; renderContrast(generateTones(baseHex, count, mode, grayHex)); } });

    buildPresets(); resetAll();
})();